const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID?.trim() ?? '';

let gaLoaded = false;

export function isGoogleAnalyticsConfigured(): boolean {
  return GA_MEASUREMENT_ID.length > 0;
}

export function getGaMeasurementId(): string {
  return GA_MEASUREMENT_ID;
}

export function initGoogleAnalytics(): boolean {
  if (!isGoogleAnalyticsConfigured() || typeof window === 'undefined') {
    return false;
  }

  if (gaLoaded) return true;

  window.dataLayer = window.dataLayer ?? [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function gtag() {
      window.dataLayer!.push(arguments as unknown);
    };
  }

  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, {
    send_page_view: false,
    anonymize_ip: true,
    allow_google_signals: false,
    allow_ad_personalization_signals: false,
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  gaLoaded = true;

  if (process.env.NODE_ENV === 'development') {
    console.info('[GA4] initialized', GA_MEASUREMENT_ID);
  }

  return true;
}

/** GA4 SPA pageview — uses gtag config (recommended by Google for SPAs). */
export function trackPageView(path: string): void {
  if (!gaLoaded || !window.gtag || !isGoogleAnalyticsConfigured()) return;

  const pagePath = path || '/';
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: pagePath,
    page_location: `${window.location.origin}${pagePath}`,
    page_title: document.title,
  });

  if (process.env.NODE_ENV === 'development') {
    console.info('[GA4] page_view', pagePath);
  }
}
